// Consent-aware Google Ads tracking (Consent Mode v2).
// IDs kommen ausschließlich aus der Konfiguration (.env) – ohne IDs bleibt alles inaktiv.
const ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID;
const CONVERSION_LABEL = process.env.REACT_APP_GOOGLE_ADS_CONVERSION_LABEL;
const CONSENT_KEY = "ftd-consent";

let gtagLoaded = false;

const ensureGtagStub = () => {
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== "function") {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }
};

export const getStoredConsent = () => {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
};

const applyConsent = (choice) => {
  ensureGtagStub();
  const granted = choice === "granted";
  window.gtag("consent", "update", {
    ad_storage: granted ? "granted" : "denied",
    ad_user_data: granted ? "granted" : "denied",
    ad_personalization: granted ? "granted" : "denied",
    analytics_storage: granted ? "granted" : "denied",
  });
};

export const storeConsent = (choice) => {
  try {
    localStorage.setItem(CONSENT_KEY, choice);
  } catch {
    /* Speicher nicht verfügbar */
  }
  applyConsent(choice);
  window.dispatchEvent(new Event("ftd-consent-changed"));
};

// Beim App-Start aufrufen: Consent-Default "denied", gtag nur laden, wenn eine ID konfiguriert ist.
export const initTracking = () => {
  ensureGtagStub();
  window.gtag("consent", "default", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
    wait_for_update: 500,
  });
  const stored = getStoredConsent();
  if (stored) applyConsent(stored);
  if (ADS_ID && !gtagLoaded) {
    gtagLoaded = true;
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${ADS_ID}`;
    document.head.appendChild(script);
    window.gtag("js", new Date());
    window.gtag("config", ADS_ID);
  }
};

// Primäre Conversion: erfolgreich versendete Kontaktanfrage.
// Wird ausschließlich nach erfolgreichem Versand aufgerufen – nie bei Seitenaufruf oder Klick.
export const trackLeadConversion = () => {
  ensureGtagStub();
  window.dataLayer.push({ event: "lead_submitted" });
  if (ADS_ID && CONVERSION_LABEL && getStoredConsent() === "granted") {
    window.gtag("event", "conversion", { send_to: `${ADS_ID}/${CONVERSION_LABEL}` });
  }
};

// Micro-Conversions: Klick auf Telefonnummer, E-Mail-Adresse oder primären Kontakt-CTA.
// Bewusst KEINE Google-Ads-Conversion – nur Engagement-Events.
export const trackMicroConversion = (type) => {
  ensureGtagStub();
  window.dataLayer.push({ event: "micro_conversion", micro_type: type });
  if (ADS_ID && getStoredConsent() === "granted") {
    const eventName =
      type === "phone" ? "click_phone" : type === "email" ? "click_email" : "click_cta";
    window.gtag("event", eventName, { event_category: "engagement" });
  }
};

// Micro-Conversion: Formular begonnen – feuert maximal einmal pro Seitenaufruf.
let formStartedFired = false;
export const trackFormStarted = () => {
  if (formStartedFired) return;
  formStartedFired = true;
  ensureGtagStub();
  window.dataLayer.push({ event: "form_started" });
  if (ADS_ID && getStoredConsent() === "granted") {
    window.gtag("event", "form_start", { event_category: "engagement" });
  }
};
